import { Component, EventEmitter, Output } from '@angular/core';
import { ProductSpecialFeature } from '../../../models/api/product-special-feature.model';
import { BaseConfirmationDialogComponent } from './../base-confirmation-dialog.component';

@Component({
  selector: 'boi-product-special-features-dialog',
  templateUrl: './product-special-features-dialog.component.html',
  styleUrls: ['./product-special-features-dialog.component.scss']
})
export class ProductSpecialFeaturesDialogComponent extends BaseConfirmationDialogComponent<
  Array<ProductSpecialFeature>
> {
  get productSpecialFeatures(): Array<ProductSpecialFeature> {
    return this.data;
  }

  @Output() public readonly cancelAction = new EventEmitter();

  public cancel(): void {
    this.cancelAction.emit();
    this.close();
  }
}
